"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var RootPageReducer_1 = require("@/pages/common/reducers/RootPageReducer");
var LoginReducer_1 = require("@/pages/common/reducers/LoginReducer");
var EnquireReducer_1 = require("@/pages/common/reducers/EnquireReducer");
var SignupReducer_1 = require("@/pages/common/reducers/SignupReducer");
var ExistingLoginReducer_1 = require("@/pages/search/reducers/ExistingLoginReducer");
var ContactReducer_1 = require("@/pages/common/reducers/ContactReducer");
var CallPopupReducer_1 = require("@/pages/callpopup/reducers/CallPopupReducer");
var rootPublicPageReducer = (__assign(__assign({}, RootPageReducer_1.rootPageReducer), { login: LoginReducer_1.loginReducer, contact: ContactReducer_1.contactReducer, enquire: EnquireReducer_1.enquireReducer, signup: SignupReducer_1.signupReducer, existingLogin: ExistingLoginReducer_1.existingLoginReducer, callPopup: CallPopupReducer_1.CallPopupReducer }));
exports.default = rootPublicPageReducer;
